@if (systemState.isSystemOutage()) {
    <ion-toolbar color="warning">
      <ion-grid>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" size-md="6">
            <span translate>GENERAL.SYSTEM_OUTAGE</span>
            <span>&nbsp;</span>
            <a [href]="environment.api.SYSTEM_OUTAGE" target="_blank">
              {{ environment.api.SYSTEM_OUTAGE }}
            </a>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-toolbar>
}
